import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06a55fdf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-contact" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "display-divider" }, "|", -1))
const _hoisted_3 = { class: "card-detail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.cardData)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.cardTheme)
      }, [
        _createElementVNode("span", {
          class: "card-remove",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeCard(_ctx.cardData.id)))
        }, "X " + _toDisplayString(_ctx.$t("removeCard.value")), 1),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("qurbanWakalah.value").toUpperCase()), 1),
          _createElementVNode("h5", null, [
            _createTextVNode(_toDisplayString(_ctx.cardData.quantity) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("share.value")), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.cardData.typeNote), 1),
          _createElementVNode("p", {
            style: _normalizeStyle([_ctx.cardData.distCountryName == 'TÜRKİYE' ? _ctx.trBgColor : '']),
            class: "dist-countryName"
          }, [
            _createTextVNode(_toDisplayString(_ctx.cardData.distCountryName), 1),
            _hoisted_2,
            _createTextVNode(_toDisplayString(_ctx.cardData.displayPrice), 1)
          ], 4)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.cardData.fullname), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.cardData.mobile), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.cardData.email), 1)
        ])
      ], 2))
    : _createCommentVNode("", true)
}